export default __webpack_public_path__ + "static/media/cross-26282A.2b893ab0.svg";